import type { BridgePolicyId, BridgePolicy } from '@gh/common/models'
import type { BookingFactRef } from '@gh/common/models'

export function buildBridgePolicyBookingFactRefs(args: {
  policyId: BridgePolicyId
  policy?: Pick<BridgePolicy, 'payerId'> | null
}): BookingFactRef[] {
  const refs: BookingFactRef[] = [{ collection: 'bridge_policies', id: args.policyId }]
  const payerId = args.policy?.payerId?.trim()
  if (payerId) {
    refs.push({ collection: 'bridge_providers', id: payerId })
  }
  return refs
}
